var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIconFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H22C26.4183 0 30 3.58172 30 8V22C30 26.4183 26.4183 30 22 30H8C3.58172 30 0 26.4183 0 22V8Z",
    fill: "#CF112D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5166 7.93779L22.8369 6.26035C22.6634 6.08691 22.4354 6 22.2077 6C21.9801 6 21.7524 6.08653 21.579 6.25996L20.2354 7.59976L23.173 10.5324L24.5166 9.19298C24.8639 8.84611 24.8639 8.2835 24.5166 7.93779Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5127 16.3065L14.4507 19.2396L22.5437 11.1615L19.6057 8.22852L11.5127 16.3065Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8787 16.9336L10.2515 20.4915L13.8167 19.8662L10.8787 16.9336Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0008 22.0765H7.92317V10.999H15.7409L17.6675 9.07617H7.24366C6.55953 9.07617 6 9.6357 6 10.3198V22.756C6 23.4402 6.55953 23.9997 7.24366 23.9997H19.6799C20.364 23.9997 20.9235 23.4402 20.9235 22.756V13.8647L19.0008 15.784V22.0765Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconFilled);
export default __webpack_public_path__ + "static/media/editIconFilled.017518782ec9760da6e3407b9437e987.svg";
export { ForwardRef as ReactComponent };